import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/auto-spares`;
export const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
export const api = {
  get: (p, params) => axios.get(`${API}${p}`, { headers: authHeaders(), params }).then((r) => r.data),
  post: (p, body) => axios.post(`${API}${p}`, body || {}, { headers: authHeaders() }).then((r) => r.data),
  put: (p, body) => axios.put(`${API}${p}`, body || {}, { headers: authHeaders() }).then((r) => r.data),
  del: (p) => axios.delete(`${API}${p}`, { headers: authHeaders() }).then((r) => r.data),
};
export const money = (n) => (n == null ? '—' : `R ${Number(n).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
export const pct = (n) => (n == null ? '—' : `${Number(n).toFixed(1)}%`);
export const errMsg = (e, d = 'Something went wrong') => e?.response?.data?.detail || d;
export const card = 'bg-slate-800/70 border-slate-700 text-white';
export const input = 'bg-slate-900 border-slate-600 text-white';
